import axios from 'axios'
const apiVersion = 'v1'
const hostname = window && window.location && window.location.hostname
const backendHost =
  hostname === 'tasklyapp.com'
    ? 'https://api.tasklyapp.com'
    : 'http://localhost:4000'

const API_ROOT = `${backendHost}/api/${apiVersion}`

const api = axios.create({
  baseURL: API_ROOT,
  timeout: 2000,
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use((response) => response.data)

export default api
